"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
function ZitchaBannerContainer({ banners }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: banners.map(banner => {
            var _a, _b, _c, _d, _e;
            return ((0, jsx_runtime_1.jsx)(cotopaxi_1.Teaser, { image: {
                    src: ((_a = banner.creative.desktop) === null || _a === void 0 ? void 0 : _a.image) || banner.creative.image,
                    alt: 'BANNER',
                    width: ((_b = banner.creative.desktop) === null || _b === void 0 ? void 0 : _b.width) || banner.creative.width,
                    height: ((_c = banner.creative.desktop) === null || _c === void 0 ? void 0 : _c.height) || banner.creative.height,
                }, title: (_d = banner.creative.headline) === null || _d === void 0 ? void 0 : _d.text, text: (_e = banner.creative.subtitle) === null || _e === void 0 ? void 0 : _e.text, CTAs: banner.creative.cta
                    ? [
                        {
                            text: banner.creative.cta.text,
                            href: banner.creative.cta.url,
                            variant: cotopaxi_1.ButtonVariant.INVERSE,
                            shape: cotopaxi_1.ButtonShape.PILL,
                        },
                    ]
                    : undefined, imageOverlay: cotopaxi_1.TeaserImageOverlay.DARK_66, innerSpacing: { padding: 4 }, href: banner.creative.url }, banner.ad_id));
        }) }));
}
exports.default = ZitchaBannerContainer;
